export const data = function() {
  return {
    isDebug: true,
    loading: false,
    architecturalRequestID: 0,
    architecturalRequest: null,
    uploadDescription: '',
    scope: '',
    tabs: [
      { name: 'architecturalRequestConversations', label: 'Conversations' },
      { name: 'architecturalRequestDetails', label: 'Details' },
      { name: 'architecturalRequestDocuments', label: 'Documents' },
      { name: 'architecturalRequestImages', label: 'Photos' }
    ],
    styles: {
      mainContainer: {
        minHeight: '1000px'
      }
    },
    transitionName: 'slide-down',
    showUploadModal: false
  }
}
